import BaseModel from './base_model';

/**
 *
 *
 *
 */
class BaseModelService extends BaseModel {
    static CLASS = 'BaseModelService';

    init(params) {}

}

export default BaseModelService;